import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import moment from "moment";

const HideBetModal = ({ open, onClose, bet, onHide }) => {
  const [hideType, setHideType] = useState("specific_bet");

  if (!bet) return null;

  const handleHide = () => {
    const baseData = {
      eventName: bet.event,
      eventStart: bet.eventStart,
      market: bet.market,
    };

    let hideData;
    switch (hideType) {
      case "specific_bet":
        hideData = {
          ...baseData,
          type: "specific_bet",
          bet: bet.bet,
          bookie: bet.bookie,
          player: bet.player,
          team: bet.team,
          line: bet.line,
        };
        break;
      case "specific_bet_all_bookies":
        hideData = {
          ...baseData,
          type: "specific_bet_all_bookies",
          bet: bet.bet,
          player: bet.player,
          team: bet.team,
          line: bet.line,
        };
        break;
      case "market_team":
        hideData = {
          ...baseData,
          type: "market_team",
          team: bet.team || bet.player,
        };
        break;
      case "market_event":
        hideData = {
          ...baseData,
          type: "market_event",
        };
        break;
      case "entire_event":
        hideData = {
          eventName: bet.event,
          eventStart: bet.eventStart,
          type: "entire_event",
        };
        break;
    }

    onHide(hideData);
    onClose();
  };

  const getTeamOrPlayer = () => {
    return bet.team || bet.player || "this selection";
  };

  const formatEventTime = () => {
    return moment(bet.eventStart).format("MMM DD, YYYY HH:mm");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Hide Bet Options</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Event: {bet.event}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Time: {formatEventTime()}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Market: {bet.market}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Selection: {bet.key}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Bookie: {bet.bookie}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <FormControl component="fieldset" fullWidth>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
            What would you like to hide?
          </Typography>
          <RadioGroup
            value={hideType}
            onChange={(e) => setHideType(e.target.value)}
          >
            <FormControlLabel
              value="specific_bet"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    This specific bet only
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Hide just this bet from {bet.bookie} for "{bet.key}"
                  </Typography>
                </Box>
              }
              sx={{ mb: 2, alignItems: "flex-start" }}
            />

            <FormControlLabel
              value="specific_bet_all_bookies"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    This bet from all bookies
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Hide "{bet.key}" from all bookies in this event
                  </Typography>
                </Box>
              }
              sx={{ mb: 2, alignItems: "flex-start" }}
            />

            {(bet.team || bet.player) && (
              <FormControlLabel
                value="market_team"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" fontWeight={500}>
                      This market for {getTeamOrPlayer()}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Hide all "{bet.market}" bets for {getTeamOrPlayer()} in
                      this event
                    </Typography>
                  </Box>
                }
                sx={{ mb: 2, alignItems: "flex-start" }}
              />
            )}

            <FormControlLabel
              value="market_event"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    This entire market for this event
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Hide all "{bet.market}" bets for both teams in this event
                  </Typography>
                </Box>
              }
              sx={{ mb: 2, alignItems: "flex-start" }}
            />

            <FormControlLabel
              value="entire_event"
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1" fontWeight={500}>
                    This entire event
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Hide all bets for "{bet.event}" on {formatEventTime()}
                  </Typography>
                </Box>
              }
              sx={{ alignItems: "flex-start" }}
            />
          </RadioGroup>
        </FormControl>

        <Box
          sx={{
            mt: 3,
            p: 2,
            backgroundColor: "background.paper",
            borderRadius: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            <strong>Note:</strong> Hidden items are specific to this event date
            and time. If the same teams play again in the future, those bets
            will not be automatically hidden.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleHide} variant="contained" color="primary">
          Hide
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HideBetModal;
